function lowerFirstCase(value) {
  if (typeof value !== 'string') return '';
  return value.charAt(0).toLowerCase() + value.slice(1);
};

export default lowerFirstCase;
